var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgHeartIconFilled = function SvgHeartIconFilled(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.52 20a1.16 1.16 0 0 1-.587-.16C5.34 16.564-.855 10.739.098 5.109.534 2.528 2.524.563 5.168.102c2.395-.416 4.712.456 6.353 2.315C13.123.605 15.368-.27 17.684.093c2.657.416 4.719 2.37 5.253 4.976 1.136 5.547-4.849 11.268-10.829 14.772a1.16 1.16 0 0 1-.587.159M6.292 2.292q-.377.001-.723.062c-1.327.231-2.863 1.175-3.194 3.132-.685 4.047 4.013 8.88 9.148 12.036 7.606-4.627 9.7-9.33 9.153-11.998-.34-1.662-1.656-2.908-3.351-3.173-1.904-.298-3.7.674-4.798 2.601-.205.36-.589.581-1.005.581-.417 0-.8-.222-1.005-.581-1.123-1.97-2.808-2.66-4.225-2.66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2 4h19v6H2zM7 10h10v6H7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9 15h5v3H9zM4 1h5v11H4zM14 1h5v11h-5zM3 3h1v2H3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8 3h2v1H8zM12 3h2v1h-2zM18 2h2v3h-2zM19 9h1v3h-1zM16 10h3v4h-3zM3 9h2v2H3zM4 12h4v2H4z"
  })));
};
export default SvgHeartIconFilled;